import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { BillingInvoiceAmount } from 'src/app/model/billing/billing-invoice-amount';
import { ClientFilter } from '../../model/client-filter';
import { BillingInvoiceItemEditInfo } from '../../model/billing/billing-invoice-item-edit-info';
import { ClientSearch } from '../../model/client-search';
import { InvoicePoint } from '../../model/invoice-point';

@Injectable({
  providedIn: 'root'
})
export class BillingInvoiceCreditAmountService {

  constructor( private dataService: DataService ) {
  }
 
  async calculateBillingInvoiceAmount(
      invoicePoint: InvoicePoint,
      items: BillingInvoiceItemEditInfo[],
      originalIIBBTaxAliquotId?: number,
      originalAmount?: number ): Promise<BillingInvoiceAmount> {

    const params = { 
        Items: items,
        InvoicePoint: invoicePoint,
        OriginalIIBBTaxAliquotId: originalIIBBTaxAliquotId,
        OriginalAmount: originalAmount
    };

    return await this.dataService
                     .post<BillingInvoiceAmount>('/billingInvoiceCreditAmount/calculateBillingInvoiceAmount/', params)
                     .toPromise();
  }
}
